const t = {
  name: "Collapse",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.4144 9.00015L22.4144 3.00015L21.0002 1.58594L15.0002 7.58594V3.00015H13.0002V11.0002H21.0002V9.00015H16.4144Z" fill="currentColor"/>
<path d="M7.58594 15.0001L1.58594 21.0001L3.00015 22.4143L9.00015 16.4143L9.00015 21.0001H11.0002L11.0002 13.0001L3.00015 13.0001L3.00015 15.0001H7.58594Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Collapse
};
